var map = {
	"./footer/en/demo.png": 74271,
	"./footer/es/demo.png": 6694,
	"./functions/consumption-first.png": 33233,
	"./functions/en/header.png": 23675,
	"./functions/es/header.png": 63242,
	"./functions/icon-consumption.png": 53019,
	"./functions/icon-integrations.png": 29073,
	"./functions/icon-supplies.png": 67196,
	"./functions/icon-tanks.png": 37155,
	"./functions/integrations-card-integration.png": 22061,
	"./functions/supplies-first.png": 66506,
	"./functions/supplies-second.png": 19980,
	"./functions/tank-card-gauge.png": 467,
	"./functions/tank-card-integration.png": 46038,
	"./home/applications-card-adblue.png": 7324,
	"./home/applications-card-electric.png": 48142,
	"./home/applications-card-fuel.png": 50681,
	"./home/applications-card-level.png": 39,
	"./home/applications-card-lubricants.png": 87578,
	"./home/applications-card-water.png": 53018,
	"./home/en/functions-tab-consumption.png": 95209,
	"./home/en/functions-tab-supplies.png": 24960,
	"./home/en/functions-tab-tanks.png": 71871,
	"./home/en/header.png": 54535,
	"./home/en/tanks-app.png": 68730,
	"./home/es/functions-tab-consumption.png": 61130,
	"./home/es/functions-tab-supplies.png": 70196,
	"./home/es/functions-tab-tanks.png": 6048,
	"./home/es/header.png": 14098,
	"./home/es/tanks-app.png": 22517,
	"./home/functions-tab-integrations.png": 94001,
	"./home/software-card-anysupply.png": 6647,
	"./home/software-card-anywhere.png": 61798,
	"./home/software-card-fleet.png": 73879,
	"./home/tools-card-additional-fields.png": 3397,
	"./home/tools-card-gaspro.png": 72622,
	"./home/tools-card-help.png": 6373,
	"./home/tools-card-permissions.png": 61621,
	"./home/tools-card-remote-access.png": 95555,
	"./home/tools-card-reports.png": 3773,
	"./home/tools-card-safe-data.png": 93376,
	"./home/tools-card-tasks.png": 82562,
	"./home/tools-card-trackers.png": 94537,
	"./home/tools-card-updates.png": 14453,
	"./youtube/home-video.png": 52634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57872;